import React from 'react';
import { instanceOf, func } from 'prop-types';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

import IconClose from '../../../shared/icons/IconClose';
import DEEditableField from '../../../shared/DEEditableField';

const SelectionsList = ({ data, onRemove, validateTargetLabel }) => {
  return data.data.map(definition => {
    const hasError = data.importValidations[definition.di] &&
      data.importValidations[definition.di].errors.includes(definition.ui)
    return (
      <Box className="de--import-def__row" key={definition.ui}>
        <div className="de--import-def__row--content">
          <DEEditableField
            row={definition}
            validateLabel={validateTargetLabel}
            hasError={hasError}
          />
          <span className="de--import-def__row--study" title={definition.sn}>
            {definition.sn}
          </span>
        </div>
        <div className="de--import-def__row--close-root">
          <IconButton
            className="de--import-def__row--close"
            type="button"
            onClick={() =>
              onRemove(false, definition, definition.di, false)
            }
            title="Remove"
          >
            <IconClose size={10} />
          </IconButton>
        </div>
      </Box>
    );
  });
};

SelectionsList.propTypes = {
  data: instanceOf(Object),
  onRemove: func,
};

export default SelectionsList;
